import { render, staticRenderFns } from "./getNumRecord.vue?vue&type=template&id=030c75ce&scoped=true&"
import script from "./getNumRecord.vue?vue&type=script&lang=js&"
export * from "./getNumRecord.vue?vue&type=script&lang=js&"
import style0 from "./getNumRecord.vue?vue&type=style&index=0&id=030c75ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c75ce",
  null
  
)

component.options.__file = "getNumRecord.vue"
export default component.exports